import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-3306">
      <div className="max-w-4xl mx-auto text-center" data-id="element-3307">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight" data-id="element-3308">
          Newsletter - Peak Machine Sales
        </h1>
      </div>
    </div>;
}